import React, { Fragment, useMemo, useRef } from "react";

import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../../../../../components/Form";
import { Color } from "../../../../../../../../../../components/Form/Button";
import { Location } from "../../../../../../../../../../models/location";
import { AddressTypeKeys } from "../../../../../../../../../../util/enums";
import AddExistingAddressModal, {
  AddExistingAddressModalHandles,
} from "../AddExistingAddressModal";
import { AddressItemOptionsButton } from "../AddressItemOptionsButton";
import ModalAddress, { AddressModalHandles } from "../AddressModal";
import {
  AddressItem,
  AddressItemDivider,
  AddressItemInfo,
  AddressItemTitle,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
} from "./styles";

interface ManageAddressesCardProps {
  type: "delivery" | "pickUp";
  emptyMessage: string;
  locations: Location[];
}

export const ManageAddressesCard = ({
  emptyMessage,
  type,
  locations,
}: ManageAddressesCardProps) => {
  const { t: translate } = useTranslation();
  const addressModalRef = useRef<AddressModalHandles>(null);
  const addExistingAddressModalRef = useRef<AddExistingAddressModalHandles>(null);
  const handleClickNewAddress = () => {
    addressModalRef?.current?.open();
  };
  const handleClickAddExistingAddress = () => {
    addExistingAddressModalRef?.current?.open();
  };
  const key = useMemo(
    () =>
      type === "delivery" ? AddressTypeKeys.DESTINATION_ADDRESS : AddressTypeKeys.ORIGIN_ADDRESS,
    [type]
  );

  return (
    <Card>
      <CardTitle>{translate(type)}</CardTitle>
      <CardBody data-cy={`${type}-card-body`}>
        {locations?.length ? (
          locations.map((location, index) => (
            <Fragment key={location.id ?? index}>
              <AddressItem>
                <div>
                  {!!location?.name && <AddressItemTitle>{location?.name}</AddressItemTitle>}
                  <AddressItemInfo>{location?.longAddress}</AddressItemInfo>
                </div>
                <AddressItemOptionsButton
                  index={index}
                  type={key}
                  handleOpenEdit={handleClickNewAddress}
                />
              </AddressItem>
              <AddressItemDivider />
            </Fragment>
          ))
        ) : (
          <Fragment>
            <AddressItem>
              <AddressItemInfo>{emptyMessage}</AddressItemInfo>
            </AddressItem>
            <AddressItemDivider />
          </Fragment>
        )}
      </CardBody>
      <CardFooter>
        <Button
          data-cy={`${type}-addExistingAddress`}
          onClick={() => handleClickAddExistingAddress()}
          customColor={Color.DEFAULT}
        >
          {translate("addExistingAddress")}
        </Button>
        <Button
          data-cy={`${type}-newAddress`}
          onClick={() => handleClickNewAddress()}
          customColor={Color.DEFAULT}
        >
          {translate("newAddress")}
        </Button>
      </CardFooter>
      <ModalAddress ref={addressModalRef} type={type} />
      <AddExistingAddressModal ref={addExistingAddressModalRef} type={type} />
    </Card>
  );
};
